import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=483bd1ad&"
import script from "./mock.vue?vue&type=script&lang=js&"
export * from "./mock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports